import { appHeaderHeight } from '@/style/constants';
import { styled } from '@uhg-abyss/web/tools/styled';

export const AppLayoutBody = styled('main', {
  minHeight: `calc(100vh - ${appHeaderHeight})`,
});
